module.exports = __webpack_public_path__ + "img/map.7b004f87.png";